<info-modal [title]="title" (onOk)="ok()">
	<div class="row">
		<div class="col-md-4">
			<span class="bg-secondary" style="width: 20px; height: 20px; display: inline-block;"></span>
			- просто рега
			<br/>
		</div>
		<div class="col-md-4">
			<span class="bg-success" style="width: 20px; height: 20px; display: inline-block;"></span>
			- рега с оплатой
			<br/>
		</div>

		<div class="col-md-4">
			<span class="bg-info" style="width: 20px; height: 20px; display: inline-block;"></span>
			- просто оплата
			<br/>
		</div>
	</div>
	
	<table class="table">
		<thead>
			<tr>
				<th>{{ 'adminstat.billing.friend.leaded' | translate }}</th>
				<th>{{ 'adminstat.billing.friend.is rereg' | translate }}</th>
				<th>{{ 'adminstat.common.total' | translate }}</th>
				<th>{{ 'adminstat.filterForm.tariffId' | translate }}</th>
			</tr>
		</thead>
		
		<tbody>
			<tr
				*ngFor="let user of userList"
				[class]="user.type == 'reg' ? 'text-secondary' : (user.type == 'paid_reg' ? 'text-success' : 'text-info')"
				title="{{ 'adminstat.billing.friend.affiliate programm' | translate }}"
			>
				<td>
					<gotosupport [value]="user.leadedUserId" [title]="(user.leadedEmail ? user.leadedEmail : user.leadedUsername)"></gotosupport>
				</td>
				
				<td title="{{user.leadedReregCount}}">
					<ng-container *ngIf="user.leadedReregCount > 1">
						<gotosupport
							[value]="user.leadedReregId"
							[title]="translate.__A('filterForm.yes')"
						></gotosupport>
					</ng-container>
					
					<ng-container *ngIf="user.leadedReregCount <= 1">
						{{ 'adminstat.filterForm.no' | translate }}
					</ng-container>
				</td>
				
				<td>
					<ng-container *ngIf="user.transaction_date">
						{{user.amount / 100}} {{user.currency}}
					</ng-container>
				</td>
				
				<td>
					<ng-container *ngIf="user.transaction_date">
						{{user.tariffId}} / {{user.tariffVariant}}
					</ng-container>
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
